"use strict";
var import_vitest = require("vitest");
var import_prebuild = require("./prebuild");
var { loadUserOneOptionsMock, prebuildMock } = import_vitest.vi.hoisted(function() {
  return {
    loadUserOneOptionsMock: import_vitest.vi.fn(),
    prebuildMock: import_vitest.vi.fn()
  };
});
import_vitest.vi.mock("../vite/loadConfig", function() {
  return {
    loadUserOneOptions: loadUserOneOptionsMock
  };
});
import_vitest.vi.mock("vxrn", function() {
  return {
    prebuild: prebuildMock
  };
});
(0, import_vitest.describe)("one prebuild", function() {
  (0, import_vitest.beforeEach)(function() {
    loadUserOneOptionsMock.mockReset();
    prebuildMock.mockReset();
  });
  (0, import_vitest.it)("loads the app bundler configuration before native prebuild", async function() {
    loadUserOneOptionsMock.mockResolvedValueOnce({});
    await (0, import_prebuild.run)({
      platform: "ios",
      expo: true,
      "no-install": true
    });
    (0, import_vitest.expect)(loadUserOneOptionsMock).toHaveBeenCalledWith("build", true);
    (0, import_vitest.expect)(loadUserOneOptionsMock.mock.invocationCallOrder[0]).toBeLessThan(prebuildMock.mock.invocationCallOrder[0]);
    (0, import_vitest.expect)(prebuildMock).toHaveBeenCalledWith({
      root: process.cwd(),
      platform: "ios",
      expo: true,
      "no-install": true
    });
  });
  (0, import_vitest.it)("does not prebuild when the app configuration fails to load", async function() {
    loadUserOneOptionsMock.mockRejectedValueOnce(new Error("invalid vite config"));
    await (0, import_vitest.expect)((0, import_prebuild.run)({
      platform: "ios",
      expo: true
    })).rejects.toThrow("invalid vite config");
    (0, import_vitest.expect)(prebuildMock).not.toHaveBeenCalled();
  });
});
//# sourceMappingURL=prebuild.test.js.map
